export default function DataService(
  $http,
  $location,
  $q,
  CreativeService,
  CurrentUserService,
  BeaconsService,
  MixpanelService
) {
  const vm = this;

  vm.save = save;
  vm.createArchivedPreview = createArchivedPreview;
  vm.userCreatives = [];
  vm.prepareCreative = prepareCreative;
  vm.destroy = destroy;
  vm.create = create;
  vm.update = update;

  const initialize = function initialize() {
    vm.data = {};
    vm.data.userId = undefined;
  };

  function prepareCreative(creative) {
    let contentStructure = creative.contentStructure;

    if (typeof contentStructure == 'object') {
      contentStructure = JSON.stringify(contentStructure);
    }

    let beacons = creative.beacons || [];
    let beaconsAttributes = BeaconsService.validBeacons(beacons);

    beaconsAttributes = BeaconsService.requiredBeacons(
      beaconsAttributes,
      creative.beaconsRequired
    );

    const slides = (creative.slides || []).map((slide, index) => ({
      ...slide,
      sortOrder: index
    }));

    // return a dco tag
    if (creative.dcoUrl) {
      return {
        action: 'clickout',
        dco_url: creative.dcoUrl,
        name: creative.name
      };
    }

    // return a "creative" to create/update instead of mutating the current
    // creative and also posting a lot of ui-focused unused attributes
    return {
      action: creative.action,
      adm: creative.adm,
      advertiser: creative.advertiser,
      behaviors: creative.behaviors,
      brandLogoUrl: creative.brandLogoUrl,
      contentStructure: contentStructure,
      customEngagementLabel: creative.customEngagementLabel,
      customEngagementUrl: creative.customEngagementUrl,
      description: creative.description,
      dsp_id: creative.dspId,
      forceClickToPlay: creative.forceClickToPlay,
      headline: creative.headline,
      id: creative.id,
      isiText: creative.isiText,
      isiAutoscroll: creative.isiAutoscroll,
      jsTracker: creative.jsTracker,
      mediaUrl: creative.mediaUrl,
      moatUrl: creative.moatUrl,
      name: creative.name,
      optOutUrl: creative.optOutUrl,
      optOutText: creative.optOutText,
      privateKey: creative.privateKey,
      promotedByText: creative.promotedByText,
      runningInEu: creative.runningInEu,
      scrollDirection: creative.scrollDirection,
      siteId: creative.siteId, // should this still be persisted on a creative?
      slides: slides,
      slidesAttributes: slides,
      slideshowAutoscroll: creative.slideshowAutoscroll,
      srtFileUrl: creative.srtFileUrl,
      status: creative.status,
      thumbnailUrl: creative.thumbnailUrl,
      vastTag: creative.vastTag,
      beacons: beaconsAttributes,
      beaconsAttributes: beaconsAttributes
    };
  }

  function save(preview) {
    CreativeService.ensureProtocol();

    if (preview.id) {
      return vm.update(preview);
    } else {
      if (!preview.name) {
        preview.name = 'New Ad';
      }

      MixpanelService.track('Ad Created', {
        headline: preview.headline
      });
      return vm.create(preview);
    }
  }

  function createArchivedPreview(preview) {
    return $http.post('/creative_previews', {
      archive: true,
      creativePreview: prepareCreative(preview)
    });
  }

  function create(creative) {
    return $http.post('/creative_previews', {
      creativePreview: prepareCreative(creative)
    });
  }

  vm.createExampleFromVariant = function createExampleFromVariant(variant) {
    return $http.post('/creative_previews', {
      archive: true,
      creativePreview: { ...variant }
    });
  };

  function update(creative) {
    return $http.patch(`/creative_previews/${creative.id}`, {
      creativePreview: prepareCreative(creative)
    });
  }

  function destroy(id) {
    return $http.delete(`/creative_previews/${id}`);
  }

  vm.getCreative = function getCreative(id) {
    return $http.get(`/creative_previews/${id}.json`);
  };

  vm.getOgContent = function getOgContent(url) {
    return $http.get(`/open_graph_data?url=${url}`);
  };

  vm.initUserCreatives = function initUserCreatives() {
    return CurrentUserService.get().then(user => {
      if (user) {
        return vm.updateUserCreatives();
      }
    });
  };

  vm.updateUserCreatives = function updateUserCreatives() {
    return $http.get('/creative_previews/user_previews').then(({ data }) => {
      vm.userCreatives = data;
    });
  };


  initialize();

  return vm;
}

DataService.$inject = [
  '$http',
  '$location',
  '$q',
  'CreativeService',
  'CurrentUserService',
  'BeaconsService',
  'MixpanelService'
];
